import * as React from "react";
import { CheckboxGroup } from "../../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { Table } from "../../../../../../Shared/Table/Table";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SectionHeader } from "../../../NewBusinessWizard/Components/SharedComponents";
import { Accordion } from "../../../../../../../react-core/Html/Accordion";
import { DocumentsAndDeclarationContent as Content } from "../../Resource/Contents";
import { DocumentTaskRequestTypeEnum } from "../../../../../../../Wrap/Constants/Enums/Tasks/DocumentTaskRequestTypeEnum";
import { PensionPathwayInvestmentOption } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/PensionPathwayInvestmentOption";
import { DownloadButton } from "../../../../../../Shared/DownloadButton/DownloadButton";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { DocumentsHelper } from "../../../PortfolioDashboard/Components/Document/Resource/DocumentsHelper";
import { processTypeEnum } from "../../../Common/Resource/Contents";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";
import { BankAccountInstruction } from "../../../../../../../Wrap/Models/Domains/Instructions/BankAccountInstruction";
import { DirectDebitMethod } from "../../../../../../../Wrap/Constants/Enums/Domain/DirectDebitMethod";
import { DirectDebitInstruction } from "../../../Common/Documents/Components/DirectDebitInstruction";
import { ESignatureDoc } from "../../../Common/Documents/Components/ESignatureDoc";
import { isJointOrTrustAccount } from "../../../NewBusinessWizard/Components/WrapperSelection/WrapperSelctionHelper";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { FullClientDetailModel } from "../../../../../../../Wrap/Models/Models/Customer/FullClientDetailModel";
import { CustomerContextStoreStatic } from "../../../NewBusinessWizard/Stores/Variable";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { NewBusinessAction } from "../../../NewBusinessWizard/Actions/NewBusinessAction";
import { Action } from "../../../../../Actions/Action";
import { AccountRole } from "../../../../../../../Wrap/Models/Domains/Account/AccountRole";
import { AddressDisplay } from "../../../../../../../react-core/Html/Address/AddressDisplay";
import { AddressDetailModel } from "../../../../../../../Wrap/Models/Models/Customer/AddressDetailModel";
import { InstructionDocumentTypeRequestTriggerActionsCreator } from "../../../Common/Documents/Actions/InstructionDocumentTypeRequestTriggerActionsCreator";

interface IDocumentsAndDeclarationsProps extends IProcessComponentProps {
    data: any;
    customerId: number;
}

interface IDocumentsAndDeclarationsState {
    checkedDeclarations: number[];
    isClientDeclarationUploaded: boolean;
    tasksForESign: { fileName: string; taskRequestId: number }[];
    customerData: FullClientDetailModel;
    senderAddress: AddressDetailModel;
}

export class DocumentsAndDeclarations extends ProcessComponent<
    IDocumentsAndDeclarationsProps,
    IDocumentsAndDeclarationsState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            isClientDeclarationUploaded: false,
            checkedDeclarations: [],
            tasksForESign: [],
            customerData: CustomerContextStoreStatic.getData(),
            senderAddress: null,
        };
    }

    onCustomerContextStoreChange() {
        const data = CustomerContextStoreStatic.getData()?.AddressDetails;
        if (data) {
            this.setState({
                customerData: CustomerContextStoreStatic.getData(),
            });
        }
    }

    componentDidMount() {
        const showInvestmentPathwayDeclaration = this.props?.data?.Contribution?.DrawdownModel?.InvestmentPathwayAnswers?.InvestmentOption == PensionPathwayInvestmentOption.InvestmentPathway;

        if (this.props.isReview) {
            this.setState({ checkedDeclarations: showInvestmentPathwayDeclaration ? [1, 2, 3, 4, 5] : [1, 2, 3, 4] });
        }

        if (!this.state.customerData && !CommonHelper.isNullOrEmpty(getQueryParameters()["hierarchyid"])) {
            Action.getAccountRoles(getQueryParameters()["hierarchyid"], (res: AccountRole[]) => {
                const actorId = res.find((x) => x.IsPrimary == true).Customer.CustomerId;
                NewBusinessAction.accountHolderAction(actorId, (res) => {
                    this.setState({ customerData: res });
                });
            });
        }

        InstructionDocumentTypeRequestTriggerActionsCreator.getAddress((address) => {
            this.setState({ senderAddress: address });
        });
    }

    isValid() {
        const showInvestmentPathwayDeclaration = this.props?.data?.Contribution?.DrawdownModel?.InvestmentPathwayAnswers?.InvestmentOption == PensionPathwayInvestmentOption.InvestmentPathway;
        const declarationsCount: number = showInvestmentPathwayDeclaration ? 5 : 4;

        if (this.state.checkedDeclarations.length < declarationsCount) {
            this.props.showErrorMsgPopUp([Content.validation.mustAcceptAll], true);
        }

        return super.isValid() && this.state.checkedDeclarations.length == declarationsCount; //&& this.state.isClientDeclarationUploaded;
    }

    render() {
        return (
            <>
                <h2>{Content.header}</h2>
                {this.renderClientDeclaration()}
                <hr className="mb-17" />

                {this.renderDocumentsToPost()}
                <hr className="mb-17" />

                {this.renderDocumentsAvailable()}
                <hr className="mb-17" />

                {this.renderEsignatureDoc()}
                <hr className="mb-17" />

                {this.renderDeclarations()}
                <hr className="mb-17" />
            </>
        );
    }

    private renderClientDeclaration() {
        const { data } = this.props;
        return (
            <>
                {SectionHeader(Content.clientDeclaration.header)}
                <p>{Content.clientDeclaration.label}</p>
                <div className="row">
                    <div className="col-11">
                        <b style={{ color: "#147cb3" }}>
                            {Content.clientDeclaration.uploadLabel(
                                data?.ClientDetails?.FirstName,
                                data?.ClientDetails?.LastName
                            )}
                        </b>
                    </div>
                    <div className="col-1">
                        <div className="row">
                            <div className="col-8">
                                <a className="download-button" target="_blank" href="">
                                    <span className="icon" aria-hidden="true"></span>
                                </a>
                            </div>
                            <div className="col-3">
                                <button className="send-email-button" onClick={() => { }}>
                                    <span className="icon" aria-hidden="true"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {!this.state.isClientDeclarationUploaded && !this.props.isReview ? (
                    <div>
                        <button
                            type="button"
                            className="upload-button mt-15"
                            onClick={() => {
                                this.setState({ isClientDeclarationUploaded: !this.state.isClientDeclarationUploaded });
                            }}
                        >
                            <span className="icon" aria-hidden="true" />
                            {Content.clientDeclaration.uploadInstruction}
                        </button>
                    </div>
                ) : (
                    <p
                        className="alert-success small"
                        onClick={() => {
                            this.setState({ isClientDeclarationUploaded: !this.state.isClientDeclarationUploaded });
                        }}
                    >
                        {Content.clientDeclaration.successfullyUploaded}
                    </p>
                )}
            </>
        );
    }

    private renderDocumentsToPost() {
        const customerid = this.props.customerId;
        const claccountid = this.props.data?.SubAccountClientDetail?.ClAccountId;
        const instructionId = getQueryParameters()["id"];
        const headAccountHierarchyId = getQueryParameters()["hierarchyid"];
        const remittanceAdviceSlipQuery = DocumentsHelper.getTaskRequest(
            instructionId,
            customerid.toString(),
            claccountid,
            headAccountHierarchyId,
            DocumentTaskRequestTypeEnum.RemittanceAdviceSlip,
            processTypeEnum.topUpWithITFLS
        );
        let transferFormQuery = null;
        const hasPensionTransfer = this.props?.data?.Contribution?.PensionTransfers?.length > 0
        if(hasPensionTransfer){
            transferFormQuery = DocumentsHelper.getTaskRequest(
                instructionId,
                customerid.toString(),
                claccountid,
                headAccountHierarchyId,
                DocumentTaskRequestTypeEnum.TransferForm,
                processTypeEnum.topUpWithITFLS
            );
        }
        
        const illustrationQuery = DocumentsHelper.getTaskRequestForBenefitCrystallisationIllustration(
            instructionId.toString().includes("-") ?
                HierarchyIdHelper.generateHierarchyId(instructionId).entityId : instructionId,
            claccountid,
            DocumentTaskRequestTypeEnum.BenefitCrystallisationIllustration
        );

        const ChargesInformationQuery = DocumentsHelper.getTaskRequest(
            instructionId,
            customerid.toString(),
            claccountid,
            headAccountHierarchyId,
            DocumentTaskRequestTypeEnum.ChargesInformation,
            processTypeEnum.topUpWithITFLS
        );

        const chargesSummaryQuery = DocumentsHelper.getTaskRequest(
            instructionId,
            customerid.toString(),
            claccountid,
            headAccountHierarchyId,
            DocumentTaskRequestTypeEnum.ChargeSummary,
            processTypeEnum.topUpWithITFLS
        );

        return (
            <>
                {SectionHeader("Documents to post")}
                {hasPensionTransfer && (
                    <div>
                        <p>Please complete this form if any of the parties are not Origo members</p>
                        <div className="mb-24">
                            <a className="hyperlink">Transfer in or re-registration form (non-Origo)</a>
                            <DownloadButton
                                request={transferFormQuery}
                                selectedAccount={headAccountHierarchyId}
                            ></DownloadButton>
                        </div>
                    </div>
                )}
                <p>For the cheque payment, your client needs to write {claccountid} on the back of their cheque</p>
                <div className="mb-24">
                    <DirectDebitInstruction
                        {...this.props}
                        data={this.props?.data}
                        processType={processTypeEnum.topUpWithITFLS}
                        needGoToDlu={false}
                        selectAll={false}
                        hideCheckBox={true}
                        triggerred={0}
                        clAccountId={claccountid}
                        onTasksForEsign={(val) => this.onTasksForEsign(val)}
                    />
                </div>
                <div className="mb-24">
                    <a className="hyperlink">Remittance Advice slip</a>
                    <DownloadButton
                        request={remittanceAdviceSlipQuery}
                        selectedAccount={headAccountHierarchyId}
                    ></DownloadButton>
                </div>
                <div className="mb-24">
                    <a className="hyperlink">Benefit Drawdown Illustration</a>
                    <DownloadButton
                        request={illustrationQuery}
                        selectedAccount={headAccountHierarchyId}
                    ></DownloadButton>
                </div>
                <div className="mb-24">
                    <a className="hyperlink">Charges Information</a>
                    <DownloadButton
                        request={ChargesInformationQuery}
                        selectedAccount={headAccountHierarchyId}
                    ></DownloadButton>
                </div>
                <div>
                    <a className="hyperlink">Charges Summary</a>
                    <DownloadButton
                        request={chargesSummaryQuery}
                        selectedAccount={headAccountHierarchyId}
                    />
                </div>
                <br />
                <div className="panel-green">
                    <p>For postal documentation, send any completed forms to:</p>{" "}
                    <AddressDisplay address={this.state.senderAddress} />
                </div>
                <hr className="mb-17" />
            </>
        );
    }

    private renderDocumentsAvailable() {
        return (
            <>
                {SectionHeader(Content.documentsAvailable.header)}
                <p>{Content.documentsAvailable.label}</p>
                <div className="row">
                    <div className="col-11">
                        <Accordion label="SIPP Documents" cssWrapper="accordion-simple" iconCss="icon-Group-6">
                            <Table
                                data={[{ FileName: "Transfer in" }, { FileName: "Remittance Advice Slip" }, { FileName: "Benefit Drawdown Illustration" }]}
                                col={[
                                    {
                                        title: "File name",
                                        key: "FileName",
                                        render: (data) => {
                                            return (
                                                <div className="row">
                                                    <div className="col-10">
                                                        <a className="hyperlink">{data}</a>
                                                    </div>
                                                    <div className="col-1">
                                                        <a className="download-button" target="_blank" href="">
                                                            <span className="icon" aria-hidden="true"></span>
                                                        </a>
                                                    </div>
                                                    <div className="col-1">
                                                        <button className="send-email-button" onClick={() => { }}>
                                                            <span className="icon" aria-hidden="true"></span>
                                                        </button>
                                                    </div>
                                                </div>
                                            );
                                        },
                                    },
                                ]}
                            />
                        </Accordion>
                    </div>
                    <div className="col-1">
                        <div className="row">
                            <div className="col-6">
                                <a className="archive-file-button" target="_blank" href="">
                                    <span className="icon" aria-hidden="true"></span>
                                </a>
                            </div>
                            <div className="col-6">
                                <button className="send-email-button" onClick={() => { }}>
                                    <span className="icon" aria-hidden="true"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    private renderDeclarations() {
        const showInvestmentPathwayDeclaration = this.props?.data?.Contribution?.DrawdownModel?.InvestmentPathwayAnswers?.InvestmentOption == PensionPathwayInvestmentOption.InvestmentPathway;

        return (
            <>
                <h2 className="mb-22">{Content.declarations.header}</h2>
                <CheckboxGroup
                    type="block"
                    wrapCss="mb-0"
                    options={[
                        {
                            label: Content.declarations.authorityToProceed,
                            disabled: this.props.isReview,
                            value: this.state.checkedDeclarations.includes(1),
                            onChange: (v) => {
                                const checked = this.state.checkedDeclarations;
                                if (v) {
                                    this.setState({ checkedDeclarations: checked.concat(1) });
                                } else {
                                    this.setState({ checkedDeclarations: checked.filter((ele) => ele != 1) });
                                }
                            },
                        },
                    ]}
                />               
                <CheckboxGroup
                    type="block"
                    wrapCss="mb-0"
                    options={[
                        {
                            label: Content.declarations.confirmList,
                            value: this.state.checkedDeclarations.includes(3),
                            disabled: this.props.isReview,
                            onChange: (v) => {
                                const checked = this.state.checkedDeclarations;
                                if (v) {
                                    this.setState({ checkedDeclarations: checked.concat(3) });
                                } else {
                                    this.setState({ checkedDeclarations: checked.filter((ele) => ele != 3) });
                                }
                            },
                        },
                    ]}
                />
                <ul className="ml-15">
                    <li className="mb-15">{Content.declarations.firstConfirm}</li>
                    <li className="mb-15">{Content.declarations.secondConfirm}</li>
                    <li className="mb-15">{Content.declarations.thirdConfirm}
                        <ul className="ml-15">
                            <li className="mb-15">{Content.declarations.thirdConfirmPointOne}</li>
                            <li className="mb-15">{Content.declarations.thirdConfirmPointTwo}</li>
                            <li className="mb-15">{Content.declarations.thirdConfirmPointThree}</li>
                        </ul>
                    </li>
                    <div className="mb-15">{Content.declarations.thirdConfirmConclusion}</div>
                </ul>
                <CheckboxGroup
                    type="block"
                    wrapCss="mb-0"
                    options={[
                        {
                            label: Content.declarations.explainedDataProtection,
                            value: this.state.checkedDeclarations.includes(4),
                            disabled: this.props.isReview,
                            onChange: (v) => {
                                const checked = this.state.checkedDeclarations;
                                if (v) {
                                    this.setState({ checkedDeclarations: checked.concat(4) });
                                } else {
                                    this.setState({ checkedDeclarations: checked.filter((ele) => ele != 4) });
                                }
                            },
                        },
                    ]}
                />
                {showInvestmentPathwayDeclaration && (
                    <CheckboxGroup
                        type="block"
                        wrapCss="mb-0"
                        options={[
                            {
                                label: Content.declarations.investmentPathway,
                                value: this.state.checkedDeclarations.includes(5),
                                disabled: this.props.isReview,
                                onChange: (v) => {
                                    const checked = this.state.checkedDeclarations;
                                    if (v) {
                                        this.setState({ checkedDeclarations: checked.concat(5) });
                                    } else {
                                        this.setState({ checkedDeclarations: checked.filter((ele) => ele != 5) });
                                    }
                                },
                            },
                        ]}
                    />
                )
                }
                <CheckboxGroup
                    type="block"
                    wrapCss="mb-0"
                    options={[
                        {
                            label: Content.declarations.confirmAll,
                            disabled: this.props.isReview,
                            value: this.state.checkedDeclarations.length == (showInvestmentPathwayDeclaration ? 5 : 4),
                            onChange: (v) => {
                                if (v) {
                                    this.setState({ checkedDeclarations: showInvestmentPathwayDeclaration ? [1, 2, 3, 4, 5] : [1, 2, 3, 4] });
                                } else {
                                    this.setState({ checkedDeclarations: [] });
                                }
                            },
                        },
                    ]}
                />
            </>
        );
    }

    private onTasksForEsign(val) {
        if (this.state.tasksForESign.some((ele) => ele.fileName == val.fileName)) {
            this.state.tasksForESign.find((ele) => ele.fileName == val.fileName).taskRequestId = val.taskRequestId;
        } else {
            this.setState({ tasksForESign: this.state.tasksForESign.concat(val) });
        }
    }

    private renderEsignatureDoc() {
        const type = Number(getQueryParameters()["type"]);

        return (
            <>
                <ESignatureDoc
                    {...this.props}
                    taskRequests={this.state.tasksForESign}
                    processType={processTypeEnum.topUpWithITFLS}
                    customerData={this.state.customerData}
                    isJointOrTrust={isJointOrTrustAccount(this.props.data?.SubAccountClientDetail?.InvestorType)}
                    isJuniorSipp={type === SubAccountType.JuniorSipp}
                />
            </>
        );
    }
}
